export default __webpack_public_path__ + "static/SaolDisplay-Regular-5c8f5feb540b36e670680b57e0fe0be7.woff2";